module.exports = __webpack_public_path__ + "img/grey-kapla-bg.852bae37.png";